import React, { useEffect, useRef, useState } from 'react';
import CardProduct from './CardProduct';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import CardProductGrid from './CardProductGrid';

import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import CardProductGridImage from './CardProductGridImage';
import NavigateToCategoryArrows from '../NavigateToCategoryArrows';
import NotifySwiperCategory from '../NotifySwiperCategory';
import { TbStar, TbStarFilled } from 'react-icons/tb';

interface ProductsProps {
    categories: any;
    loading: boolean;
}

const Products = ({
    categories = [],
    loading
}: ProductsProps) => {

    const { viewMode, isMobile, forceViewModeSwiperImage, setForceViewModeSwiperImage, isCategoriesSwiperViewed, setIsCategoriesSwiperViewed } = useLayoutContext();
    const swiperRefMenu = useRef<SwiperRef>(null);
    const swiperRefProducts = useRef<SwiperRef>(null);
    const swiperRefProductsImage = useRef<SwiperRef>(null);
    const [currentSwiperSlide, setCurrentSwiperSlide] = useState(0);
    const [isVisibleSwipeInfo, setIsVisibleSwipeInfo] = useState(false);

    const handleCurrentSlide = (index: number) => {
        setCurrentSwiperSlide(index);
        if (swiperRefProducts.current && swiperRefProducts.current.swiper && swiperRefMenu.current && swiperRefMenu.current.swiper) {
            swiperRefProducts.current.swiper.slideTo(index);
            swiperRefMenu.current.swiper.slideTo(index);

            if (swiperRefProductsImage.current && swiperRefProductsImage.current.swiper) {
                swiperRefProductsImage.current.swiper.slideTo(index);
            }

            //* Scroll to position menu on change slide
            const boxProductsSwiper = document.getElementById('boxProductsSwiper');
            if (boxProductsSwiper) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }

    useEffect(() => {
        handleCurrentSlide(currentSwiperSlide)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewMode])

    useEffect(() => {
        if (!loading) {
            setForceViewModeSwiperImage(categories[currentSwiperSlide].layout === 'swiper_image' && isMobile);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSwiperSlide, loading])

    const toggleVisibilityMenu = () => {
        const boxProducts = document.getElementById('boxProductsSwiper');
        const rect = boxProducts?.getBoundingClientRect();
        const boxProductsPosition = rect ? rect.top + window.scrollY - 100 : 0;
        if (boxProducts && window.scrollY > 100 && window.scrollY > boxProductsPosition) {
            setIsVisibleSwipeInfo(true);
        } else {
            setIsVisibleSwipeInfo(false);
        }
    }

    useEffect(() => {
        if (!isCategoriesSwiperViewed) {
            window.addEventListener('scroll', toggleVisibilityMenu);
        }
        return () => {
            window.removeEventListener('scroll', toggleVisibilityMenu);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCategoriesSwiperViewed]);

    useEffect(() => {
        setCurrentSwiperSlide(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    const handleCategoriesSwiperViewed = () => {
        setIsCategoriesSwiperViewed(true);
    }

    return (
        <>
            {(forceViewModeSwiperImage || viewMode === 'swiper' || viewMode === 'swiper_image') &&
                <div className='grid grid-rows-[auto,1fr] h-full'>

                        <section className='overflow-hidden sticky top-20 bg-white/95 z-10 pb-2 -mt-3'>
                            {/* -mt-3 utilizado acima para remover o pt-3 do CONTENT do DefaultLayout */}
                            <Swiper
                                ref={swiperRefMenu}
                                spaceBetween={0}
                                centeredSlides={true}
                                slideToClickedSlide={true}
                                slidesPerView={'auto'}
                                id='swiperMenuCategories'
                                >
                                {
                                    categories.map((category: any, index: number) => (
                                        <SwiperSlide
                                            key={category.id} data-hash={`slide${category.id}`}
                                            data-active={currentSwiperSlide === index}
                                            onClick={() => handleCurrentSlide(index)}
                                            className={`
                                                w-auto
                                                cursor-grab active:cursor-grabbing pb-2 p-4 border-b-4
                                                transition-border ease-in-out duration-200
                                                leading-4
                                                flex items-center h-full justify-center text-nowrap
                                                max-w-fit
                                                min-w-content
                                                ${!loading && currentSwiperSlide === index ? 'border-custom-primary text-custom-primary font-extrabold' : 'border-transparent font-medium'}`}
                                            >
                                            <div className="flex items-center gap-1">
                                                {loading ? (
                                                    <div className="flex w-32 h-4 bg-gray-200 rounded-lg animate-pulse" />
                                                ) : (
                                                    <>
                                                        {category.name}
                                                        {category.layout === 'swiper_image' && (
                                                            currentSwiperSlide === index
                                                            ? <TbStarFilled className="zoomInIconNoDelay" />
                                                            : <TbStar />
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </section>

                        <NotifySwiperCategory
                            show={!isCategoriesSwiperViewed && isVisibleSwipeInfo && !loading}
                            onClickConfirm={handleCategoriesSwiperViewed}
                        />

                        { /* swiper */ }
                        <Swiper
                            ref={swiperRefProducts}
                            spaceBetween={0}
                            slideToClickedSlide={true}
                            slidesPerView={'auto'}
                            autoHeight={true}
                            onSlideChange={(e: any) => {
                                handleCurrentSlide(e.activeIndex);
                                handleCategoriesSwiperViewed();
                            }}
                            id='boxProductsSwiper'
                            className="relative w-full self-start"
                            style={{
                                height: !forceViewModeSwiperImage && viewMode === "swiper" ? 'auto' : '0',
                                overflow: !forceViewModeSwiperImage && viewMode === "swiper" ? '' : 'hidden'
                            }}
                        >
                            {categories?.map((category: any, index: number) =>
                                <SwiperSlide
                                    key={`${index}_${category.id}`}
                                    data-hash={`slide${category.id}`}
                                    data-active={currentSwiperSlide === index}
                                    className="w-full min-w-full cursor-pointer p-1 h-full min-h-dvh cursor-grab active:cursor-grabbing"
                                    >
                                        
                                    {category.description && <div className='text-sm text-center text-gray-400 italic pb-3 leading-4'>{ category.description }</div>}

                                    <section className={`
                                        grid
                                        w-full
                                        gap-2 md:gap-3 lg:gap-4 xl:gap-5
                                        grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7
                                        transition-width ease-in-out duration-200  ${isVisibleSwipeInfo && !isCategoriesSwiperViewed && 'opacity-25'}`}>
                                        {category.products.map((product: any, index: number) =>
                                            <CardProductGrid
                                                product={product}
                                                category={category}
                                                loading={loading}
                                                key={index}
                                            />
                                        )}

                                        <NavigateToCategoryArrows
                                            show={!loading}
                                            index={index}
                                            categoryPrevName={index > 0 ? categories[index - 1].name : null}
                                            categoryNextName={index < categories.length - 1 ? categories[index + 1].name : null}
                                            showPrev={index > 0}
                                            showNext={index < categories.length - 1}
                                            onClickCategory={(e: number) => handleCurrentSlide(e)}
                                        />
                                    </section>

                                </SwiperSlide>
                            )}
                        </Swiper>

                        { /* swiper_image */ }
                        <Swiper
                            ref={swiperRefProductsImage}
                            spaceBetween={0}
                            slideToClickedSlide={true}
                            slidesPerView={'auto'}
                            autoHeight={true}
                            onSlideChange={(e: any) => {
                                handleCurrentSlide(e.activeIndex);
                                handleCategoriesSwiperViewed();
                            }}
                            id='boxProductsSwiperImage'
                            className="relative w-full self-start"
                            style={{
                                height: forceViewModeSwiperImage || viewMode === "swiper_image" ? 'auto' : '0',
                                overflow: forceViewModeSwiperImage || viewMode === "swiper_image" ? '' : 'hidden'
                            }}
                        >
                            {categories?.map((category: any, index: number) =>
                                <SwiperSlide
                                    key={`${index}_${category.id}`}
                                    data-hash={`slide${category.id}`}
                                    data-active={currentSwiperSlide === index}
                                    className="w-full min-w-full h-full min-h-dvh cursor-pointer p-1 cursor-grab active:cursor-grabbing"
                                    >

                                    {category.description && <div className='text-sm text-center text-gray-400 italic pb-3 leading-4'>{ category.description }</div>}

                                    <section className={`
                                        grid
                                        w-full
                                        gap-2 md:gap-3 lg:gap-4 xl:gap-5
                                        grid-cols-2
                                        transition-width ease-in-out duration-200  ${isVisibleSwipeInfo && !isCategoriesSwiperViewed && 'opacity-25'}`}>
                                        {category.products.map((product: any, index: number) => {
                                            let extraClasses = "";
                                            const patternIndex = index % 12; // Repetir padrão a cada 12 itens

                                            if (patternIndex === 0) {
                                                extraClasses = "row-span-2";
                                            } else if (patternIndex === 1 || patternIndex === 2 || patternIndex === 4 || patternIndex === 5 || patternIndex === 6 || patternIndex === 8) {
                                                extraClasses = "";
                                            } else if (patternIndex === 3) {
                                                extraClasses = "col-span-2";
                                            } else if (patternIndex === 7) {
                                                extraClasses = "row-span-2";
                                            } else if (patternIndex === 9) {
                                                extraClasses = "col-span-2";
                                            }

                                            return (
                                                <CardProductGridImage
                                                    className={extraClasses}
                                                    product={product}
                                                    category={category}
                                                    loading={loading}
                                                    key={index}
                                                />
                                            );
                                        })}

                                        <NavigateToCategoryArrows
                                            show={!loading}
                                            index={index}
                                            categoryPrevName={index > 0 ? categories[index - 1].name : null}
                                            categoryNextName={index < categories.length - 1 ? categories[index + 1].name : null}
                                            showPrev={index > 0}
                                            showNext={index < categories.length - 1}
                                            onClickCategory={(e: number) => handleCurrentSlide(e)}
                                        />
                                    </section>

                                </SwiperSlide>
                            )}
                        </Swiper>
                </div>
            }

            {(viewMode === 'list' || viewMode === 'grid') &&
                <div id='boxProducts' className='grid grid-rows-[auto,1fr] h-full p-2 gap-12'>
                    {categories?.map((category: any, index: number) =>
                        <div key={index} className='categoryListScroll' id={`_${index}`}>
                            <h2 id={`category_${category.id}`} className={`grid gap-0.5 mb-6`}>
                                <span className='text-xl font-extrabold text-gray-800'>{category.name}</span>
                                {category.description && <span className='text-lg leading-5'>{ category.description }</span>}
                            </h2>

                            {viewMode === 'list' &&
                                <section className='grid md:grid-cols-2 xl:grid-cols-3 gap-3 md:gap-4 lg:gap-6 transition-width ease-in-out duration-200'>
                                    {category.products.map((product: any, index: number) =>
                                        <CardProduct product={product} category={category} loading={loading} key={index} />
                                    )}
                                </section>
                            }

                            {viewMode === 'grid' &&
                                <section className='grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-2 md:gap-3 lg:gap-4 xl:gap-5 transition-width ease-in-out duration-200'>
                                    {category.products.map((product: any, index: number) =>
                                        <CardProductGrid product={product} category={category} loading={loading} key={index} />
                                    )}
                                </section>
                            }
                        </div>
                    )}
                </div>
            }
        </>
    )
}

export default Products;
